import { DocumentEmbeddingStatus } from "../../../types/documents";

interface DocumentStatusBadgeProps {
  status: DocumentEmbeddingStatus;
  errorDetails?: string;
}

export function DocumentStatusBadge({
  status,
  errorDetails,
}: DocumentStatusBadgeProps) {
  const config: Record<
    string,
    {
      bg: string;
      text: string;
      border: string;
      label: string;
      icon: JSX.Element;
    }
  > = {
    embedded: {
      bg: "bg-green-50",
      text: "text-green-700",
      border: "border-green-200",
      label: "Ready",
      icon: (
        <span className="text-green-600 font-semibold text-xs">✓</span>
      ),
    },
    not_embedded: {
      bg: "bg-yellow-50",
      text: "text-yellow-700",
      border: "border-yellow-200",
      label: "Needs Embedding",
      icon: (
        <span className="text-yellow-600 font-semibold text-xs">⚠</span>
      ),
    },
    error: {
      bg: "bg-red-50",
      text: "text-red-700",
      border: "border-red-200",
      label: "Error",
      icon: <span className="text-red-600 font-semibold text-xs">✕</span>,
    },
  };

  const fallback = {
    bg: "bg-gray-50",
    text: "text-gray-700",
    border: "border-gray-200",
    label: status ? String(status) : "Unknown",
    icon: <span className="text-gray-600 font-semibold text-xs">?</span>,
  };

  const { bg, text, border, label, icon } = config[status] ?? fallback;

  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg border ${bg} ${text} ${border}`}
      title={errorDetails || undefined}
    >
      <span className="flex items-center justify-center">{icon}</span>
      <span className="text-xs font-medium whitespace-nowrap">
        {label}
      </span>
    </div>
  );
}
